"use client";

import { useEffect } from "react";

export function EventViewTracker({ eventId }: { eventId: string }) {
  useEffect(() => {
    const body = JSON.stringify({ eventId });
    if (navigator.sendBeacon) {
      navigator.sendBeacon("/api/events/view", body);
      return;
    }

    fetch("/api/events/view", {
      method: "POST",
      body,
      keepalive: true,
      headers: { "content-type": "application/json" }
    }).catch(() => undefined);
  }, [eventId]);

  return null;
}
